// https://gist.github.com/nicholaswmin/c2661eb11cad5671d816
export function getCurvedPathItems (data, alpha = 1) {
  const items = []
  const length = data.length

  for (var i = 0; i < length - 1; i++) {
    const p0 = i === 0 ? data[0] : data[i - 1]
    const p1 = data[i]
    const p2 = data[i + 1]
    const p3 = i + 2 < length ? data[i + 2] : p2

    const d1 = Math.sqrt(Math.pow(p0.x - p1.x, 2) + Math.pow(p0.y - p1.y, 2))
    const d2 = Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2))
    const d3 = Math.sqrt(Math.pow(p2.x - p3.x, 2) + Math.pow(p2.y - p3.y, 2))

    const d1powA = Math.pow(d1, alpha)
    const d1pow2A = Math.pow(d1, 2 * alpha)
    const d2powA = Math.pow(d2, alpha)
    const d2pow2A = Math.pow(d2, 2 * alpha)
    const d3powA = Math.pow(d3, alpha)
    const d3pow2A = Math.pow(d3, 2 * alpha)

    const A = 2 * d1pow2A + 3 * d1powA * d2powA + d2pow2A
    const B = 2 * d3pow2A + 3 * d3powA * d2powA + d2pow2A
    let N = 3 * d1powA * (d1powA + d2powA)
    let M = 3 * d3powA * (d3powA + d2powA)

    if (N > 0) {
      N = 1 / N
    }

    if (M > 0) {
      M = 1 / M
    }

    let bp1 = {
      x: (-d2pow2A * p0.x + A * p1.x + d1pow2A * p2.x) * N,
      y: (-d2pow2A * p0.y + A * p1.y + d1pow2A * p2.y) * N
    }

    let bp2 = {
      x: (d3pow2A * p1.x + B * p2.x - d2pow2A * p3.x) * M,
      y: (d3pow2A * p1.y + B * p2.y - d2pow2A * p3.y) * M
    }

    if (bp1.x === 0 && bp1.y === 0) {
      bp1 = p1
    }

    if (bp2.x === 0 && bp2.y === 0) {
      bp2 = p2
    }

    const d = `M ${p1.x} ${p1.y} C ${bp1.x} ${bp1.y}, ${bp2.x} ${bp2.y}, ${p2.x} ${p2.y}`

    items.push({
      d
    })
  }

  return items
}
